/**
 * Created by Omar Alejandro Leonor Avalos on 2017-06-14.
 * Helpers for reducers
 */
import {
    setValueIn,
    addArrayItemIn,
    deleteArrayItemIn,
    setValuesIn,
    updateItemIn,
    addPropertyInArray,
} from '../immutable';
import { parsePath } from './general';

const operations = {
    update: (path, value, state) => setValueIn(path, value, state),
    add: (path, value, state) => addArrayItemIn(path, value, state),
    remove: (path, value, state) => deleteArrayItemIn(path, value, state),
    multiUpdate: (targets, state) => setValuesIn(targets, state),
    updateItem: (path, value, state) => updateItemIn(path, value, state),
    addProperty: (path, node, nodeValue, newProperty, propertyValue, state) => addPropertyInArray(path, node, nodeValue, newProperty, propertyValue, state)
};

/**
 * Returns a new state with new properties
 * @param {Object} payload contains this posible values {op,targets, path, value}
 * @param {Object} state the state to update
 */
export const updateState = (payload, state) => {
    return payload.op === 'multiUpdate' ? operations.multiUpdate(payload.targets, state) :
        operations[payload.op || 'update'](parsePath(payload.path), payload.value, state);
};

export const addPropertyInItem = (payload, state) => {
    return operations['addProperty'](payload.path,
        payload.propertyInPath,
        payload.valueToCompare,
        payload.newProperty,
        payload.propertyValue, state);
};



// WEBPACK FOOTER //
// ./common/helpers/reducer.js